module.exports = __webpack_public_path__ + "img/blue-square-table-12.50ecc94e.png";